export enum SidePanelEvent {
  OPEN = 'SidePanelEvent:OPEN',
  CLOSE = 'SidePanelEvent:CLOSE'
}
